import { render, staticRenderFns } from "./horizontal-table.vue?vue&type=template&id=f09beb16&"
import script from "./horizontal-table.vue?vue&type=script&lang=js&"
export * from "./horizontal-table.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-table.vue?vue&type=style&index=0&id=f09beb16&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f09beb16')) {
      api.createRecord('f09beb16', component.options)
    } else {
      api.reload('f09beb16', component.options)
    }
    module.hot.accept("./horizontal-table.vue?vue&type=template&id=f09beb16&", function () {
      api.rerender('f09beb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/horizontal-table.vue"
export default component.exports